<script setup>
  import { computed } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import SubscriptionList from './components/registrationSubscription/SubscriptionList.vue'

  const route = useRoute()
  const router = useRouter()
  const meetingCode = computed(() => (typeof route.query.meetingCode === 'string' ? route.query.meetingCode : ''))
  const meetingName = computed(() => (typeof route.query.meetingName === 'string' ? route.query.meetingName : ''))
</script>

<template>
  <div class="meeting-subscription-container">
    <el-page-header content="报名结果订阅" @back="router.back()" />
    <p>{{ meetingName }}（{{ meetingCode }}）</p>
    <subscription-list v-if="meetingCode" :key="meetingCode" :meeting-code="meetingCode" />
    <el-empty v-else description="缺少会议编码，请返回会议管理" />
  </div>
</template>
